<div class="hero-dark"></div>
<div class="container">
  <div class="flex align-items-center justify-content-between mb-5">
    <h1>Gestione <span class="green">preventivi</span></h1>
  </div>
  <p-table
    [value]="leads"
    [paginator]="true"
    [rows]="5"
    [lazy]="true"
    (onLazyLoad)="getAllBookings($event)"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali"
    #dt1
    selectionMode="single"
    (onRowSelect)="open($event)"
    [(selection)]="selectedLead"
    dataKey="identifier"
    [loading]="loading"
    styleClass="my-5"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Codice richiesta</th>
        <th>Utente</th>
        <th>Data richiesta</th>
        <th>Destinazione</th>
        <th>Stato</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-l>
      <tr [pSelectableRow]="l">
        <td>
          <code>{{ l.identifier }}</code>
        </td>
        <td>
          <div class="flex align-items-center gap-2">
            <i class="pi pi-users"></i> {{ l.from }}
          </div>
        </td>
        <td>{{ l.when | date : "dd/MM/YYYY HH:mm" }}</td>
        <td>{{ l.country }}</td>
        <td [innerHTML]="l.status.id | leadStatus"></td>
        <td></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">
          <div class="empty-set px-0">
            <img src="/assets/media/illustrations/map.png" height="200" />
            <h5>Nessuna richiesta di preventivo</h5>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
